"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var disaggregation_classifier_1 = require("./disaggregation.classifier");
var DisaggregationSerializer = /** @class */ (function () {
    function DisaggregationSerializer() {
    }
    DisaggregationSerializer.convertDisaggregation = function (json) {
        var disaggregations = new Array();
        for (var _i = 0, json_1 = json; _i < json_1.length; _i++) {
            var dis = json_1[_i];
            var disaggregationClassifier = new disaggregation_classifier_1.DisaggregationClassifier(dis["id"], dis["systemName"], new idm_crosscutting_concepts_frontend_1.MultilingualString(DisaggregationSerializer.getMultilingualMap(dis["name"])));
            disaggregations.push(disaggregationClassifier);
        }
        return disaggregations;
    };
    DisaggregationSerializer.getMultilingualMap = function (json) {
        var map = new Map();
        for (var k in json) {
            map.set(Number(k), json[k]);
        }
        return map;
    };
    DisaggregationSerializer.convertDisaggregationTypes = function (data) {
        var disaggregation = new Array();
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var dis = data_1[_i];
            disaggregation.push(new disaggregation_classifier_1.DisaggregationClassifier(dis.getId(), null, dis.getMultilingualName()));
        }
        return disaggregation;
    };
    return DisaggregationSerializer;
}());
exports.DisaggregationSerializer = DisaggregationSerializer;
//# sourceMappingURL=disaggregation.serializer.js.map